import "../styles/navbar.css";



function openTalkdesk() {
  window.webchat.open();
}

export function NavBar() {
  return (
    <>
      <div className="">
        <div className="navBarContainer">
          <div className="nav mobilenav">
            <div className="links">
              <img className="navBarLogo" src="https://mdcreactdev.wpenginepowered.com/wp-content/reactpress/apps/mdc/build/logo-new.png" alt="logo" />
              {/* <div className="icon-question pt5 ml10">
                <div onClick={openTalkdesk}>
                  <img className="icon-chat" src="https://mdcreactdev.wpenginepowered.com/wp-content/reactpress/apps/mdc/build/icon-chat.png" alt="logo" />
                </div>
              </div> */}
            </div>
            
            <div className="icons">

            </div>
          </div>
        </div>
      </div>
    </>
  );
}
